import { supabase } from '../supabaseClient';

async function getInventoryStatusId(status) {
    const { data, error } = await supabase
        .from('InventoryStatus')
        .select('*')
        .eq('status', status).single();
    if (data) return { data };
    else throw error;
}
async function getInventoryStatusStringFromId(statusId) {
    const { data, error } = await supabase
        .from('InventoryStatus')
        .select('*')
        .eq('inventoryStatusId', statusId).single();
    if (data) return { data };
    else throw error;
}
async function getInventory(projectId) {
    let statusId = await getInventoryStatusId('Available');
    let query = supabase.from('Inventory').select('*,wingId(*)').eq('projectId', projectId).eq('inventoryStatusId', statusId.data.inventoryStatusId)
    const { data, error, } = await query;
    if (data) return data;
    else throw error;
}
// ??This function is used in changeUnit (Modal) as well as alotExistingUnit (Modal)
async function getInventoryExceptSelectedOne(projectId, unitNo) {
    let statusId = await getInventoryStatusId('Available');
    let query = supabase.from('Inventory').select('*,wingId(*)').eq('projectId', projectId).eq('inventoryStatusId', statusId.data.inventoryStatusId)
    .neq('unitId', unitNo)
    const { data, error, } = await query;
    if (data) return data;
    else throw error;
}
async function getBookingAmount(projectId, wingId, inventoryTypeId) {
    let query = supabase.from('BookingAmounts').select('*').eq('projectId', projectId).eq('wingId', wingId).eq('inventoryTypeId', inventoryTypeId)
    const { data, error, } = await query;
    if (data) return data;
    else throw error;
}
// ??this function is also used in alotExisitngUnit Modal
async function updateInventoryStatus(unitId, statusId, leadId) {
    // let statusId = await getInventoryStatusId();
    const { data, error, count } = await supabase
        .from('Inventory')
        .update({ leadId: leadId, inventoryStatusId: statusId })
        .eq('unitId', unitId)
    if (data) return { data, count };
    else throw error;
}

// Freed (old) unit on a unit-shift accept: release it AND zero its costing so it
// enters the reprice queue. Only for the old unit being freed on accept -- never
// for occupying the new unit.
async function freeAndZeroInventoryForChangeUnit(unitId, statusId) {
    const { data, error, count } = await supabase
        .from('Inventory')
        .update({ leadId: null, inventoryStatusId: statusId, BSP: 0, GST: 0, SDR: 0, totalCost: 0 })
        .eq('unitId', unitId)
    if (data) return { data, count };
    else throw error;
}

async function updateAllotmentUnitId(allotmentPaymentId, unitId,bookingAmt,unitCost,status,paidAmount,paymentPlanId) {
    const { data, error, count } = await supabase
        .from('AllotmentPayment')
        .update({ unitId: unitId,bookingAmt:bookingAmt,unitCost:unitCost,status ,paidAmount:paidAmount,paidAmt:null,paymentPlanId:paymentPlanId})
        .eq('allotmentPaymentId', allotmentPaymentId)
        .select("*,CRM!left(*)")
    if (data) return { data, count };
    else throw error;
}
async function updateAllotmentTransactions(allotmentPaymentId, unitId) {
    const { data, error, count } = await supabase
        .from('AllotmentTransactions')
        .update({ unitId: unitId})
        .eq('allotmentPaymentId', allotmentPaymentId)
    if (data) return { data, count };
    else throw error;
}
async function updateAllotmentTransactionsForTrnsUpdate(allotmentPaymentId, obj) {
    const { data, error, count } = await supabase
        .from('AllotmentTransactions')
        .update(obj)
        .eq('allotmentPaymentId', allotmentPaymentId)
        .eq('status','complete')
    if (data) return { data, count };
    else throw error;
}
export { getInventory, getInventoryExceptSelectedOne, getBookingAmount, updateInventoryStatus,
     getInventoryStatusStringFromId, getInventoryStatusId, updateAllotmentUnitId ,updateAllotmentTransactions,updateAllotmentTransactionsForTrnsUpdate,
     freeAndZeroInventoryForChangeUnit}
     